export default __webpack_public_path__ + "static/media/CinzelDecorative-Regular.93903ebf.ttf";